import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getPatternImages } from '../../../../../helpers/getPatternImages';
import { getProductType } from '../../../../../helpers/getProductType';

export const LiftControl = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patternUrl = getPatternImages(state);
  const productType = getProductType(state.context);

  let cordColourHex = 'url(#cordColour)';

  return (
    <svg
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 9.67 456.95"
      {...props}
      preserveAspectRatio="none"
    >
      <defs>
        <style>
          {'.prefix__cls-2{fill:gray}.prefix__cls-3{fill:#e0e0e0;opacity:.75}'}
        </style>
      </defs>
      <rect
        x={3.33}
        width={3}
        height={437.51}
        rx={1}
        fill="#fff"
        opacity={0.5}
      />
      <path d="M4.34 1h1v435.51h-1z" />
      <path
        className="prefix__cls-2"
        d="M.69 436.28H9a.69.69 0 01.69.69v2.53H0V437a.69.69 0 01.69-.69z"
      />
      <path
        className="prefix__cls-3"
        d="M0 439.5h9.67v17.45H0zM.69 125.45H9a.69.69 0 01.69.69v2.53H0v-2.53a.69.69 0 01.69-.69z"
      />
      <path className="prefix__cls-2" d="M0 128.68h9.67v17.45H0z" />
    </svg>
  );
};
